import { Show, SimpleShowLayout } from "react-admin";
import CyclicExamGeneralInfo from "./CyclicExamGeneralInfo";
import CyclicExamProfessorsInfo from "./CyclicExamProfessorsInfo";
import CyclicExamSlots from "./CyclicExamSlots";
import BackButtonToolbar from "features/BackButtonToolbar";

const ShowCyclicExam = () => {
  return (
    <Show
      title="Детайли за цикличен изпит"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <CyclicExamGeneralInfo />

        <CyclicExamProfessorsInfo />
        <CyclicExamSlots />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowCyclicExam;
